import { atom } from "recoil";
import { ResponseGetAllBasesResponse } from "../../services/OpenAPI";

export const baseSearchOptionsAtom = atom<{
  baseSearchOptions: ResponseGetAllBasesResponse[] | null;
}>({
  key: "baseSearchOptionsAtom",
  default: {
    baseSearchOptions: null,
  },
});
